<template>
	<el-card class="menuStep">
		<div class="stepMain clearfloat">
			<!-- 步骤图片 -->
			<div class="imgBox left clearfloat">
				<i
					v-if="base64"
					class="el-icon-close deleteBtn"
					@click="handleDeleteImg('image')"
				></i>
				<el-upload
					ref="image"
					class="avatar-uploader"
					:auto-upload="false"
					action="/lexy/api/common/saveMenuImage"
					:limit="1"
					:show-file-list="false"
					:on-change="(file, filesList) => handleChoseFile(file)"
					accept=".jpg"
					style="width: 300px; height: 360px"
				>
					<img v-if="base64" :src="base64" class="avatarAppImage" />
					<div v-else class="userAdvert-add">单击上传</div>
				</el-upload>
				<div class="imgTip">图片比例：1 : 1.2</div>
				<div class="imgTip">支持拓展名: .jpg</div>
			</div>
			<!-- 步骤/属性 表单 -->
			<div class="formBox right clearfloat">
				<!-- 步骤 -->
				<el-form
					ref="form"
					label-width="120px"
					:model="form"
					:rules="rules"
				>
					<el-form-item label="步骤类型" prop="stepsType">
						<el-select
							v-model="form.stepsType"
							@change="handleSwitchStepsType"
						>
							<el-option
								v-for="item in types"
								:key="item.value"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						v-if="form.stepsType != 1"
						label="步骤描述"
						prop="stepsDescribe"
					>
						<el-input
							class="textarea"
							type="textarea"
							rows="3"
							v-model="form.stepsDescribe"
						></el-input>
					</el-form-item>
					<el-form-item
						label="启动前步骤描述"
						v-if="form.stepsType == 1"
						prop="beforeDescribe"
					>
						<el-input
							class="textarea"
							type="textarea"
							rows="3"
							v-model="form.beforeDescribe"
						></el-input>
					</el-form-item>
					<el-form-item
						label="启动中步骤描述"
						v-if="form.stepsType == 1"
						prop="runningDescribe"
					>
						<el-input
							class="textarea"
							type="textarea"
							rows="3"
							v-model="form.runningDescribe"
						></el-input>
					</el-form-item>
					<el-form-item
						label="暂停中步骤描述"
						v-if="form.stepsType == 1"
						prop="stopDescribe"
					>
						<el-input
							class="textarea"
							type="textarea"
							rows="3"
							v-model="form.stopDescribe"
						></el-input>
					</el-form-item>
					<el-form-item label="菜谱模型">
						<el-select
							clearable
							v-model="form.menuModelId"
							@change="getMenuModelPropList"
						>
							<el-option
								v-for="item in propertes"
								:key="item.id"
								:value="item.id"
								:label="item.propertyName"
							></el-option>
						</el-select>
					</el-form-item>
					<!-- —————————————— 属性 —————————————— -->
					<el-form-item label-width="0" prop="menuModelId">
						<el-form
							label-width="120px"
							v-if="form.propertyList.length"
						>
							<el-form-item label="属性ID">
								<div class="propName">属性名称</div>
								<div class="propSet">参数设置</div>
							</el-form-item>
							<el-form-item
								class="marginT10"
								v-for="(item, index) in form.propertyList"
								:key="item.id"
								:label="escapeCMDID(item.cmdId)"
							>
								<div class="propName">
									{{ item.propertyName }}
								</div>
								<!-- 烹饪时间 -->
								<div
									class="propSet"
									v-if="item.identify == 'cook_time_s'"
								>
									<el-input
										type="number"
										class="formInputTime"
										v-model.trim="min"
										@change="handleSeconed(index)"
									>
										<template slot="append">分</template>
									</el-input>
									<el-input
										type="number"
										class="formInputTime marginL20"
										v-model.trim="sec"
										@change="handleSeconed(index)"
									>
										<template slot="append">秒</template>
									</el-input>
								</div>
								<!-- 其他属性 -->
								<div class="propSet" v-else>
									<!-- int / float -->
									<el-input-number
										class="formInput"
										v-if="
											item.propertyType == 1 ||
											item.propertyType == 2 ||
											item.propertyType == 3
										"
										:max="item.processBounds.max"
										:min="item.processBounds.min"
										v-model.trim="item.value"
										@change="handleValName(index, item)"
									></el-input-number>
									<!-- string -->
									<!-- <el-input
								class="formInput"
								v-if="item.propertyType == 3"
								v-model.trim="item.value"
								@change="handleValName(index,item)"
									></el-input>-->
									<!-- enum -->
									<el-select
										class="formInput"
										v-if="item.propertyType == 5"
										v-model="item.value"
										@change="handleValName(index, item)"
									>
										<el-option
											v-for="(
												bound, idx
											) in item.processBounds"
											:key="idx"
											:value="Number(idx)"
											:label="bound"
										></el-option>
									</el-select>
									<!-- boolean -->
									<el-select
										class="formInput"
										v-if="item.propertyType == 6"
										v-model="item.value"
										@change="handleValName(index, item)"
									>
										<el-option
											v-for="(
												bound, idx
											) in item.processBounds"
											:key="idx"
											:value="idx == 'trueValue' ? 1 : 0"
											:label="bound"
										></el-option>
									</el-select>
								</div>
							</el-form-item>
						</el-form>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</el-card>
</template>

<script>
import { Message } from "element-ui";
export default {
	name: "menuStep",
	props: [
		"propertes",
		"stepForm",
		"idenList",
		"childPropList",
		"stepIdx",
		"stepPeople",
	],
	data() {
		var stepsDescribeCheck = (rule, value, callback) => {
			let len = 0,
				limit = JSON.parse(this.idenList.stepsDescribe.bounds).size;
			if (this.idenList.stepsDescribe.charcodec == "GBK") {
				len = this.$utils.getStrLengGBK(value);
			} else {
				len = this.$utils.getStrLengUTF8(value);
			}
			if (len > limit) {
				callback(
					new Error(
						"字数过长，字数限制：" +
							limit +
							"（" +
							this.idenList.stepsDescribe.charcodec +
							"）"
					)
				);
			} else if (len < 1) {
				callback(new Error("请输入步骤描述"));
			} else {
				callback();
			}
		};
		var runningDescribeCheck = (rule, value, callback) => {
			if (this.form.stepsType == 1) {
				let len = 0,
					limit = JSON.parse(this.idenList.runningDescribe.bounds)
						.size;
				if (this.idenList.runningDescribe.charcodec == "GBK") {
					len = this.$utils.getStrLengGBK(value);
				} else {
					len = this.$utils.getStrLengUTF8(value);
				}
				if (len > limit) {
					callback(
						new Error(
							"字数过长，字数限制：" +
								limit +
								"（" +
								this.idenList.runningDescribe.charcodec +
								"）"
						)
					);
				} else if (len < 1) {
					callback(new Error("请输入启动中步骤描述"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var stopDescribeCheck = (rule, value, callback) => {
			if (this.form.stepsType == 1) {
				let len = 0,
					limit = JSON.parse(this.idenList.stopDescribe.bounds).size;
				if (this.idenList.stopDescribe.charcodec == "GBK") {
					len = this.$utils.getStrLengGBK(value);
				} else {
					len = this.$utils.getStrLengUTF8(value);
				}
				if (len > limit) {
					callback(
						new Error(
							"字数过长，字数限制：" +
								limit +
								"（" +
								this.idenList.stopDescribe.charcodec +
								"）"
						)
					);
				} else if (len < 1) {
					callback(new Error("请输入暂停中步骤描述"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var beforeDescribeCheck = (rule, value, callback) => {
			if (this.form.stepsType == 1) {
				let len = 0,
					limit = JSON.parse(this.idenList.beforeDescribe.bounds)
						.size;
				if (this.idenList.beforeDescribe.charcodec == "GBK") {
					len = this.$utils.getStrLengGBK(value);
				} else {
					len = this.$utils.getStrLengUTF8(value);
				}
				if (len > limit) {
					callback(
						new Error(
							"字数过长，字数限制：" +
								limit +
								"（" +
								this.idenList.beforeDescribe.charcodec +
								"）"
						)
					);
				} else if (len < 1) {
					callback(new Error("请输入启动前步骤描述"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var menuModelIdCheck = (rule, value, callback) => {
			if (value != "" && value != null) {
				let list = Object.assign([], this.form.propertyList);
				for (let i in list) {
					if (
						list[i].value === "" ||
						list[i].value === null ||
						list[i].value === undefined
					) {
						callback(
							new Error("请完善菜谱模型，若无需菜谱模型则删除")
						);
					} else {
						// 限制int float 最小值 最大值
						if (
							list[i].propertyType == 1 ||
							list[i].propertyType == 2
						) {
							if (
								list[i].value < list[i].processBounds.min ||
								list[i].value > list[i].processBounds.max
							) {
								callback(
									new Error(
										"属性：" +
											list[i].propertyName +
											"，限制范围为" +
											JSON.stringify(
												list[i].processBounds
											)
									)
								);
							}
							callback();
						}
					}
				}
				callback();
			} else {
				callback();
			}
		};
		return {
			min: "",
			sec: "",
			rules: {
				stepsDescribe: [
					{ validator: stepsDescribeCheck, trigger: "blur" },
				],
				runningDescribe: [
					{ validator: runningDescribeCheck, trigger: "blur" },
				],
				stopDescribe: [
					{ validator: stopDescribeCheck, trigger: "blur" },
				],
				beforeDescribe: [
					{ validator: beforeDescribeCheck, trigger: "blur" },
				],
				menuModelId: [{ validator: menuModelIdCheck, trigger: "blur" }],
			},
			types: [
				{
					label: "放料",
					value: 0,
				},
				{
					label: "执行",
					value: 1,
				},
				{
					label: "结束",
					value: 2,
				},
			],
			base64: null,
			file: null,
			// 表单数据
			form: {
				stepsType: "", // 步骤类型：0 放料，1 执行，2 结束
				// 以下描述，针对type不为1 的时候存在
				stepsDescribe: "", // 步骤描述（当type为1，describe相当于启动前描述）
				// 以下描述，针对type为1 执行的时候存在
				beforeDescribe: "", // 启动前描述
				runningDescribe: "", // 启动中步骤描述
				stopDescribe: "", // 暂停中描述
				stepAudio: "", // 步骤语音描述
				stepImage: "", // 步骤图片名
				menuModelId: "", // 菜谱模型（属性结构体id）
				propertyList: [],
			},
		};
	},
	created() {
		// 来自编辑
		if (this.stepForm.stepsStep) {
			let form = Object.assign({}, this.stepForm),
				list = Object.assign([], this.stepForm.propertyList);
			// 处理图片
			if (form.stepImage) {
				this.base64 =
					this.$store.state.oldStore.imgSrc +
					form.stepImage +
					"&token=" +
					this.$store.state.oldStore.token;
			}
			// 处理属性
			if (form.menuModelId) {
				for (let x in list) {
					// 处理取值范围
					if (JSON.parse(list[x].bounds).items) {
						list[x].processBounds = JSON.parse(
							list[x].bounds
						).items;
					} else {
						list[x].processBounds = JSON.parse(list[x].bounds);
					}
					// 处理时间 sec=>min+sec
					if (list[x].identify == "cook_time_s") {
						let val = Number(list[x].value);
						this.min = val < 60 ? 0 : parseInt(Number(val / 60));
						this.sec = val - this.min * 60;
					}
				}
				form.propertyList = list;
			}
			this.$set(this, "form", form);
		}
	},
	methods: {
		getData: function () {
			return {
				file: this.file,
				form: this.form,
				base64: this.base64,
			};
		},
		// 当修改菜谱模型
		getMenuModelPropList: function (val) {
			if (val) {
				this.min = 0;
				this.sec = 0;
				this.$http
					.productModelFuncInfo({ propertyId: val })
					.then((res) => {
						if (res.data.success) {
							let para = Object.assign({}, res.data.data);
							for (let i in para.subProperties) {
								para.subProperties[i].propertyType =
									para.subProperties[i].type;
							}
							this.dealProp(para);
						}
					});
			} else {
				this.form.propertyList = [];
				this.min = 0;
				this.sec = 0;
			}
		},
		// 提交表单
		handleSubmit: function () {
			let flag = false;
			this.$refs.form.validate((valid) => {
				if (valid) {
					flag = true;
				}
			});
			if (flag) {
				return {
					file: this.file,
					form: this.form,
					base64: this.base64,
				};
			} else {
				return {
					result: false,
					stepIdx: this.stepIdx,
					stepPeople: this.stepPeople,
				};
			}
		},
		// 获取传入表单
		assignForm: function (para) {
			// 来自新增-移动-删除
			if (para.form) {
				let obj = Object.assign({}, para.form),
					list = Object.assign([], para.form.propertyList);
				for (let x in list) {
					if (list[x].identify == "cook_time_s") {
						this.min = parseInt(list[x].value / 60);
						this.sec = list[x].value - this.min * 60;
					}
				}
				obj.propertyList = list;
				this.base64 = para.base64;
				this.$set(this, "base64", para.base64);
				this.$set(this, "file", para.file);
				this.$set(this, "form", obj);
			}
		},
		// 选择文件
		handleChoseFile: function (file) {
			let _this = this,
				reader = new FileReader(),
				image = new Image(),
				base64 = null;
			image.onload = function () {
				let num = image.height / image.width;
				if (num != 1.2) {
					Message.error("图片尺寸比例错误");
					_this.$refs.image.clearFiles();
				} else {
					_this.base64 = base64;
					_this.file = file.raw;
					_this.$refs.image.clearFiles();
				}
			};
			reader.onload = function (e) {
				base64 = e.target.result;
				image.src = base64;
			};
			reader.readAsDataURL(file.raw);
		},
		// 获取valueName
		handleValName: function (idx, item) {
			let list = Object.assign([], this.form.propertyList);
			if (
				list[idx].propertyType == 1 ||
				list[idx].propertyType == 2 ||
				list[idx].propertyType == 3
			) {
				list[idx].value = item.value;
				list[idx].valueName = item.value;
			} else {
				list[idx].value = item.value;
				list[idx].valueName = list[idx].processBounds[item.value];
			}
		},
		// 删除照片
		handleDeleteImg: function () {
			this.base64 = "";
			this.file = "";
			this.form.stepImage = "";
			this.$refs.image.clearFiles();
		},
		// 处理属性值
		dealProp: function (prop) {
			if (this.form.propertyList.length > 0) {
				let list = Object.assign([], prop.subProperties);
				for (let i in this.form.propertyList) {
					for (let x in list) {
						// 获取传入表单中的值
						if (
							list[x].identify ==
							this.form.propertyList[i].identify
						) {
							list[x].value = this.form.propertyList[i].value;
							list[x].valueName = this.form.propertyList[
								i
							].valueName;
						}
						// 获取的取值范围
						if (JSON.parse(list[x].bounds).items) {
							list[x].processBounds = JSON.parse(
								list[x].bounds
							).items;
						} else {
							list[x].processBounds = JSON.parse(list[x].bounds);
						}
						// 传入单位
						list[x].propertyUnit = list[x].unit;
						list[x].propertyId = list[x].id;
						// 初始设置烹饪时间最小值
						if (list[x].identify == "cook_time_s") {
							let min = list[x].processBounds.min % 60;
							this.min = min;
							this.sec = list[x].processBounds.min - min * 60;
							list[x].value = min;
						}
					}
				}
				this.form.propertyList = list;
			} else {
				this.form.propertyList = prop.subProperties;
				this.form.propertyList.forEach((item) => {
					item.propertyUnit = item.unit;
					item.propertyId = item.id;
					if (JSON.parse(item.bounds).items) {
						item.processBounds = JSON.parse(item.bounds).items;
					} else {
						item.processBounds = JSON.parse(item.bounds);
					}
					if (item.identify == "cook_time_s") {
						let min = item.processBounds.min % 60;
						this.min = min;
						this.sec = item.processBounds.min - min * 60;
						item.value = min;
					}
				});
			}
		},
		// 获得秒数
		handleSeconed: function (idx) {
			let list = Object.assign([], this.form.propertyList);
			list[idx].value = Number(this.min) * 60 + Number(this.sec);
			this.$set(this.form, "propertyList", list);
		},
		// 切换步骤类型
		handleSwitchStepsType: function () {
			let obj = Object.assign({}, this.form);
			obj.stepsDescribe = ""; // 步骤描述
			obj.beforeDescribe = ""; // 启动前描述
			obj.runningDescribe = ""; // 启动中步骤描述
			obj.stopDescribe = ""; // 暂停中描述
			obj.menuModelId = ""; // 菜谱模型（属性结构体id）
			obj.propertyList = [];
			this.$set(this, "form", obj);
		},
		getMaxMin(prop) {
			console.log(prop);
			return 0;
		},
		// 转译cmdId
		escapeCMDID: function (val) {
			let res = val;
			return res.toString(16).padStart(4, "0").toUpperCase();
		},
	},
};
</script>

<style lang='less' scoped>
.menuStep {
	.formBox {
		min-width: 600px;
	}
	.avatar-uploader {
		position: relative;
		display: block;
		margin-bottom: 6px;
	}
	.avatarImage {
		width: 300px;
		height: 360px;
	}
	.avatarAppImage {
		width: 300px;
		height: 360px;
	}

	.avatar-uploader {
		border: 1px dashed #d9d9d9;
	}
	.avatar-uploader:hover {
		border-color: #409eff;
	}
	.avatar-uploader .el-upload {
		float: left;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		height: 100%;
		width: 100%;
	}
	.userAdvert-add {
		color: #8c939d;
		font-size: 22px;
		width: 300px;
		height: 360px;
		line-height: 360px;
		text-align: center;
	}
	.imgTip {
		font-size: 14px;
		color: #bbb;
		text-align: center;
	}
	.textarea {
		width: 400px;
	}
	.propName {
		width: 120px;
		text-align: center;
		display: inline-block;
	}
	.propSet {
		display: inline-block;
		width: 300px;
	}
	.formInput {
		width: 300px;
	}
	.formInputTime {
		width: 140px;
	}
	.deleteBtn {
		z-index: 999;
		cursor: pointer;
		position: absolute;
		width: 20px;
		height: 20px;
		background: red;
		border-radius: 10px;
		color: #fff;
		font-weight: 600;
		line-height: 20px;
		text-align: center;
		top: -10px;
		right: -10px;
	}
	.imgBox {
		position: relative;
	}
}
</style>